import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ControlFailureSectionProp } from ".";
import { DATE_UTIL } from "../../../../../utils/dateUtils";



const ReportViewSection = (props: ControlFailureSectionProp) => {


    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="section-wrapper">
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbReporterName")}
                    >
                        <span>{data.reporter_name}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbReporterDivision")}
                    >
                        <span>{data.reporter_division?.name} - {data.reporter_business_unit?.name}</span>
                    </Form.Item>
                </Col>
            </Row>


            <Row gutter={[16, 32]}>
                <Col span={12}>
                    <Form.Item
                        label={t("ControlFailure.lbEmail")}
                    >
                        <span>{data.reporter_email}</span>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={t("ControlFailure.lbPhone")}
                    >
                        <span>{data.reporter_phone}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbApprovalName")}
                    >
                        <span>{data.approval_name}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbRecordingDate")}
                    >
                        <span>{DATE_UTIL.convertServerToViewFormat(data.recording_date)}</span>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default ReportViewSection;